export default __webpack_public_path__ + "static/media/7.4f04a9e5.jpg";